export enum SigningAlgorithm {
	SHA_1 = 'sha1',
	SHA_256 = 'sha256',
	SHA_512 = 'sha512'
}